import { createSlice } from '@reduxjs/toolkit';
import ApiService from 'services/ApiService';
import axios from 'services/ApiAdaptor';

const getMultipartConfig = () => {
  const token = window.localStorage.getItem('serviceToken');
  const config = {
    headers: {
      'content-type': 'multipart/form-data'
    }
  };
  if (token) {
    config.headers['x-access-token'] = token;
  }
  return config;
};

const initialState = {
  lists: {
    items: [],
    totalItems: 0
  },
  currentPage: 0,
  pageSize: 150,
  error: null,
  list: null
};

const slice = createSlice({
  name: 'materialPlanOut',
  initialState,
  reducers: {
    hasError(state, action) {
      state.error = action.payload;
    },
    getLists(state, action) {
      state.lists = action.payload;
      state.currentPage = action.payload.currentPage;
      state.pageSize = action.payload.pageSize;
    },
    getSingleList(state, action) {
      state.list = action.payload;
    },
    createMaterialPlanOut(state, action) {
      state.lists.items = [...state.lists.items, action.payload];
      state.lists.totalItems += 1;
    },
    updateMaterialPlanOut(state, action) {
      const updatedMaterialPlanOut = action.payload;
      state.lists.items = state.lists.items.map((item) => (item.id === updatedMaterialPlanOut.id ? updatedMaterialPlanOut : item));
    },
    deleteMaterialPlanOut(state, action) {
      const materialPlanOutId = action.payload;
      state.lists.items = state.lists.items.filter((item) => item.id !== materialPlanOutId);
      state.lists.totalItems -= 1;
    }
  }
});

export const { getLists, getSingleList, createMaterialPlanOut, updateMaterialPlanOut, deleteMaterialPlanOut } = slice.actions;

export default slice.reducer;

export function getMaterialPlanOutList(page, pageSize) {
  return async (dispatch) => {
    try {
      const objData = {
        path: '/materialPlanOut/list',
        params: { page, pageSize }
      };
      const response = await ApiService.get(objData);
      dispatch(
        getLists({
          items: response.data.items,
          totalItems: response.data.totalItems,
          currentPage: page - 1,
          pageSize: pageSize
        })
      );
    } catch (error) {
      dispatch(slice.actions.hasError(error.toString()));
    }
  };
}

export function getMaterialPlanOutInsert(NewLists) {
  return async (dispatch) => {
    try {
      const data = new FormData();
      Object.keys(NewLists).forEach((key) => {
        if (key === 'files' && NewLists[key] && NewLists[key][0]) {
          data.append('file', NewLists[key][0]);
        } else if (NewLists[key] !== null && NewLists[key] !== undefined) {
          data.append(key, NewLists[key]);
        }
      });
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/materialPlanOut/materialPlanOutUpload`, data, getMultipartConfig());
      if (response.status === 200) {
        dispatch(createMaterialPlanOut(response.data));
        return { success: true, data: response.data };
      } else {
        return { success: false, message: response.data.message };
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error.toString()));
      return { success: false, error };
    }
  };
}

export function getMaterialPlanOutSingleList(materialPlanOutId) {
  return async (dispatch) => {
    try {
      const response = await axios.post('/api/materialPlanOut/list/single', { id: materialPlanOutId });
      dispatch(getSingleList(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.toString()));
    }
  };
}

export function getMaterialPlanOutUpdate(NewLists, id, flag) {
  return async (dispatch) => {
    try {
      let response;
      if (flag === 'Y') {
        const data = new FormData();
        Object.keys(NewLists).forEach((key) => {
          if (key === 'files' && NewLists[key] && NewLists[key][0]) {
            data.append('file', NewLists[key][0]);
          } else if (NewLists[key] !== null && NewLists[key] !== undefined) {
            data.append(key, NewLists[key]);
          }
        });
        response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/materialPlanOut/materialPlanOutUpdate`, data, getMultipartConfig());
      } else {
        const objData = {
          path: '/materialPlanOut/update',
          data: NewLists
        };
        response = await ApiService.post(objData);
      }

      if (response.status === 200) {
        dispatch(updateMaterialPlanOut(response.data));
        return { success: true, data: response.data };
      } else {
        return { success: false, message: response.data.message };
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error.toString()));
      return { success: false, error };
    }
  };
}

export function getMaterialPlanOutDelete(materialPlanOutId) {
  return async (dispatch) => {
    try {
      const objData = {
        path: '/materialPlanOut/delete',
        data: { id: materialPlanOutId }
      };
      const response = await ApiService.post(objData);
      if (response.status === 200) {
        dispatch(deleteMaterialPlanOut(materialPlanOutId));
        return { success: true, data: response.data };
      } else {
        throw new Error(response.data.message);
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error.toString()));
      throw error;
    }
  };
}
